import React from "react";
import PropTypes from "prop-types";
import { Subtitle, SubtitleLabel } from "./_.styled";
import ContentHeaderSubtitleItem from "../ContentHeaderSubtitleItem";

const ContentHeaderSubtitle = ({ title, subTitles, testId, pageType }) => (
  <Subtitle data-testid={testId} pageType={pageType}>
    {title && (
      <SubtitleLabel
        element="span"
        color="primary"
        fontWeight="semibold"
        textTransform="uppercase"
      >
        {title.label}:&nbsp;
      </SubtitleLabel>
    )}
    {subTitles.map((subtitle) => (
      <ContentHeaderSubtitleItem
        key={subtitle.id}
        {...subtitle}
        pageType={pageType}
      />
    ))}
  </Subtitle>
);

ContentHeaderSubtitle.propTypes = {
  title: PropTypes.shape({
    label: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
  }),
  subTitles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      heading: PropTypes.string,
      title: PropTypes.string,
      pronunciation: PropTypes.string,
      content: PropTypes.arrayOf(PropTypes.string.isRequired),
      testId: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        testId: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
  testId: PropTypes.string.isRequired,
};

ContentHeaderSubtitle.displayName = "ContentHeaderSubtitle";

export default ContentHeaderSubtitle;
